module.exports = __webpack_public_path__ + "static/media/icon-back.06791acb.svg";